/**
 * Rasa Contact form – submits to external PHP endpoint via fetch.
 * Uses FormData so PHP receives standard $_POST (contact_name, email, organization_name, message).
 */
document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('RasaContactForm');
  if (!form) return;

  const formAction = (form.getAttribute('data-form-action') || '').trim();
  const submitButton = form.querySelector('button[type="submit"]');
  const successMessage = form.querySelector('.get-in-touch__message--success');
  const errorMessage = form.querySelector('.get-in-touch__message--error');
  const errorMessageText = errorMessage && errorMessage.querySelector('.get-in-touch__message-text');
  const messageField = document.getElementById('RasaContact-message');
  const charCount = document.getElementById('RasaContact-message-counter');

  if (messageField && charCount) {
    messageField.addEventListener('input', function () {
      const remaining = 5000 - this.value.length;
      charCount.textContent = remaining + ' characters remaining';
      if (remaining < 100) {
        charCount.classList.add('get-in-touch__char-count--warning');
      } else {
        charCount.classList.remove('get-in-touch__char-count--warning');
      }
    });
  }

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    if (successMessage) successMessage.classList.remove('visible');
    if (errorMessage) errorMessage.classList.remove('visible');

    if (!formAction) {
      if (errorMessageText) {
        errorMessageText.textContent = 'Form is not configured. Please set the form endpoint URL in the theme editor.';
      }
      if (errorMessage) errorMessage.classList.add('visible');
      return;
    }

    if (messageField && messageField.value.length > 5000) {
      if (errorMessageText) errorMessageText.textContent = 'Message exceeds 5000 character limit.';
      if (errorMessage) errorMessage.classList.add('visible');
      return;
    }

    submitButton.disabled = true;
    submitButton.textContent = 'Sending...';
    form.classList.add('loading');

    const formData = new FormData(form);

    try {
      const response = await fetch(formAction, {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        if (successMessage) successMessage.classList.add('visible');
        if (errorMessage) errorMessage.classList.remove('visible');
        form.reset();
        if (charCount) {
          charCount.textContent = '5000 characters remaining';
          charCount.classList.remove('get-in-touch__char-count--warning');
        }
        if (successMessage) {
          successMessage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          setTimeout(function () {
            successMessage.classList.remove('visible');
          }, 5000);
        }
      } else {
        throw new Error('Server returned ' + response.status);
      }
    } catch (err) {
      if (errorMessageText) {
        errorMessageText.textContent = 'There was an error submitting the form. Please try again.';
      }
      if (errorMessage) errorMessage.classList.add('visible');
      if (errorMessage) errorMessage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    } finally {
      submitButton.disabled = false;
      submitButton.textContent = 'Send Message';
      form.classList.remove('loading');
    }
  });
});
